import { ArrowUpRight, BookOpen, Briefcase, Car, Compass, Gift, Home, Plane, Users } from "lucide-react";
import { FadeUp, SectionHeading } from "./Reveal";

const OFFERS = [
  { icon: Users, label: "Travel concierge & personalised assistance" },
  { icon: Plane, label: "Airport arrivals & chauffeur-driven transport" },
  { icon: Compass, label: "Tours, experiences & cultural discovery" },
  { icon: Home, label: "Accommodation & short stays" },
  { icon: Car, label: "Relocation & settling-in support" },
  { icon: Briefcase, label: "Investment & property-related resources" },
  { icon: BookOpen, label: "Practical Nigerian A–Z guides" },
  { icon: Gift, label: "Curated welcome packages & gifts" },
];

export const WhatWeDo = () => (
  <section data-testid="what-we-do-section" className="border-y border-jawa-stone bg-white">
    <div className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32">
      <FadeUp>
        <SectionHeading overline="What JÀWÀ Africa does" title="One trusted team for your Nigerian journey." />
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-jawa-espresso/70">
          JÀWÀ brings together the practical pieces of visiting, returning to or settling into Nigeria — so
          instead of figuring everything out alone, you find practical resources, bookable experiences and
          personalised assistance in one place.
        </p>
      </FadeUp>
      <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {OFFERS.map((o, i) => (
          <FadeUp key={o.label} delay={i * 0.05}>
            <div
              className="flex h-full items-start gap-3 border border-jawa-stone bg-jawa-ivory p-5 transition-colors hover:border-jawa-turquoise/60"
              data-testid={`what-we-do-${o.label.toLowerCase().replace(/[^a-z0-9]+/g, "-").slice(0, 40)}`}
            >
              <o.icon className="mt-0.5 h-5 w-5 shrink-0 text-jawa-coral" />
              <p className="text-sm font-medium leading-snug text-jawa-espresso">{o.label}</p>
            </div>
          </FadeUp>
        ))}
      </div>
      <FadeUp className="mt-10">
        <a
          href="/services"
          data-testid="what-we-do-cta"
          className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.25em] text-jawa-turquoise transition-colors hover:text-jawa-espresso"
        >
          See everything JÀWÀ can help with <ArrowUpRight className="h-4 w-4" />
        </a>
      </FadeUp>
    </div>
  </section>
);
